import { Button } from 'reactstrap';
import Icon from '../assets/icons/Icon';

const CardButton = (props) => {
    const {
        children,
        disabled,
        onClick = () => null,
        buttonTitle,
        testID,
        type,
    } = props;

    const getBackgroundImage = () => {
        switch (type) {
            case 'darkBlue': {
                return 'linear-gradient(to right, #3E50BD , #4173E8)';
            }
            case 'lightBlue':
            default: {
                return 'linear-gradient(to right, #4EAEFE , #58E2FE)';
            }
        }
    };

    return (
        <Button
            className="w-100 p-3 text-left border-0 d-flex justify-content-between align-items-center"
            color="primary"
            style={{
                backgroundImage: disabled ? undefined : getBackgroundImage(),
                backgroundColor: disabled ? 'gray' : undefined,
                outline: 'none',
            }}
            onClick={onClick}
            disabled={disabled}
        >
            <p className="font-weight-bold text-white mr-3">{buttonTitle}</p>
            {children}
            <Icon
                icon="ChevronRight"
                className="m-0 w-auto h-auto"
                width={25}
            />
        </Button>
    );
};

export default CardButton;
